export const timezones = [
    {
        name:"(UTC-12:00) International Date Line West",
        offsetHour:-12,
        offsetMin:0
    },
    {
        name:"(UTC-10:00) Aleutian Islands, Hawaii",
        offsetHour:-10,
        offsetMin:0
    },
    {
        name:"(UTC-09:30) Marquesas Islands",
        offsetHour:-9,
        offsetMin:30
    },
    {
        name:"(UTC-09:00) Alaska",
        offsetHour:-9,
        offsetMin:0
    },
    {
        name:"(UTC-08:00) Baja California, Pacific Time (US & Canada)",
        offsetHour:-8,
        offsetMin:0
    },
    {
        name:"(UTC-07:00) Arizona, Chihuahua, La Paz, Mazatlan, Mountain Time (US & Canada)",
        offsetHour:-7,
        offsetMin:0
    },
    {
        name:"(UTC-06:00) Central America, Central Time (US & Canada) Easter Island, Guadalajara, Mexico City, Monterrey, Saskatchewan",
        offsetHour:-6,
        offsetMin:0
    },
    {
        name:"(UTC-05:00) Bogota, Lima, Quito, Rio Branco, Chetumal, Eastern Time (US & Canada), Haiti, Havana, Indiana (East), Turks and Caicos",
        offsetHour:-5,
        offsetMin:0
    },
    {
        name:"(UTC-04:00) Asuncion, Atlantic Time (Canada), Caracas, Cuiaba, Georgetown, La Paz, Manaus, San Juan, Santiago",
        offsetHour:-4,
        offsetMin:0
    },
    {
        name:"(UTC-03:30) Newfoundland",
        offsetHour:-3,
        offsetMin:30
    },
    {
        name:"(UTC-03:00) Araguaina, Brasilia, Cayenne, Fortaleza, City of Buenos Aires, Greenland, Montevideo, Punta Arenas, Saint Pierre and Miquelon, Salvador",
        offsetHour:-3,
        offsetMin:0
    },
    {
        name:"(UTC-02:00) Mid-Atlantic - Old",
        offsetHour:-2,
        offsetMin:0
    },
    {
        name:"(UTC-01:00) Azores, Cabo Verde Is",
        offsetHour:-1,
        offsetMin:0
    },
    {
        name:"(UTC 00:00) Coordinated Universal Time, Casablanca, Dublin, Edinburgh, Lisbon, London, Monrovia, Reykjavik",
        offsetHour:0,
        offsetMin:0
    },
    {
        name:"(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna, Belgrade, Bratislava, Budapest, Ljubljana, Prague, Brussels, Copenhagen, Madrid, Paris, Sao Tome, Sarajevo, Skopje, Warsaw, Zagreb, West Central Africa",
        offsetHour:1,
        offsetMin:0
    },
    {
        name:"(UTC+02:00) Amman, Athens, Bucharest, Beirut, Cairo, Chisinau, Damascus, Gaza, Hebron, Harare, Pretoria, Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius, Jerusalem, Kaliningrad, Khartoum, Tripoli, Windhoek",
        offsetHour:2,
        offsetMin:0
    },
    {
        name:"(UTC+03:00) Baghdad, Istanbul, Kuwait, Riyadh, Minsk, Moscow, St. Petersburg, Volgograd, Nairobi",
        offsetHour:3,
        offsetMin:0
    },
    {
        name:"(UTC+03:30) Tehran",
        offsetHour:3,
        offsetMin:30
    },
    {
        name:"(UTC+04:00) Abu Dhabi, Muscat, Astrakhan, Ulyanovsk, Baku, Izhevsk, Samara, Port Louis, Saratov, Tbilisi, Yerevan",
        offsetHour:4,
        offsetMin:0
    },
    {
        name:"(UTC+04:30) Kabul",
        offsetHour:4,
        offsetMin:30
    },
    {
        name:"(UTC+05:00) Ashgabat, Tashkent, Ekaterinburg, Islamabad, Karachi",
        offsetHour:5,
        offsetMin:0
    },
    {
        name:"(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi, Sri Jayawardenepura",
        offsetHour:5,
        offsetMin:30
    },
    {
        name:"(UTC+05:45) Kathmandu",
        offsetHour:5,
        offsetMin:45
    },
    {
        name:"(UTC+06:00) Astana, Dhaka, Omsk",
        offsetHour:6,
        offsetMin:0
    },
    {
        name:"(UTC+06:30) Yangon (Rangoon)",
        offsetHour:6,
        offsetMin:30
    },
    {
        name:"(UTC+07:00) Bangkok, Hanoi, Jakarta, Barnaul, Gorno-Altaysk, Hovd, Krasnoyarsk, Novosibirsk, Tomsk",
        offsetHour:7,
        offsetMin:0
    },
    {
        name:"(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi, Irkutsk, Kuala Lumpur, Singapore, Perth, Taipei, Ulaanbaatar",
        offsetHour:8,
        offsetMin:0
    },
    {
        name:"(UTC+08:45) Eucla",
        offsetHour:8,
        offsetMin:45
    },
    {
        name:"(UTC+09:00) Chita, Osaka, Sapporo, Tokyo, Pyongyang, Seoul, Yakutsk",
        offsetHour:9,
        offsetMin:0
    },
    {
        name:"(UTC+09:30) Adelaide, Darwin",
        offsetHour:9,
        offsetMin:30
    },
    {
        name:"(UTC+10:00) Brisbane, Canberra, Melbourne, Sydney, Guam, Port Moresby, Hobart, Vladivostok",
        offsetHour:10,
        offsetMin:0
    },
    {
        name:"(UTC+10:30) Lord Howe Island",
        offsetHour:10,
        offsetMin:30
    },
    {
        name:"(UTC+11:00) Bougainville Island, Chokurdakh, Magadan, Norfolk Island, Sakhalin, Solomon Is., New Caledonia",
        offsetHour:11,
        offsetMin:0
    },
    {
        name:"(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky, Auckland, Wellington, Fiji, Petropavlovsk-Kamchatsky - Old",
        offsetHour:12,
        offsetMin:0
    },
    {
        name:"(UTC+12:45) Chatham Islands",
        offsetHour:12,
        offsetMin:45
    },
    {
        name:"(UTC+13:00) Nuku'alofa, Samoa",
        offsetHour:13,
        offsetMin:0
    }
]


// WEBPACK FOOTER //
// ./src/portal/data/timezones.js